module.exports = __webpack_public_path__ + "static/media/step2.72761578.png";